export const EXPANDED_FACTOR = 2.5;

export const getChartHeight = (height: number, isExpanded: boolean) => {
  return isExpanded ? height * EXPANDED_FACTOR : height;
};
